(() => {
  if (!window.benivox) {
    window.benivox = {
      money(cents) {
        const valor = Number(cents || 0) / 100;
        const formato = window.benivoxMoneyFormat;
        if (!formato) return new Intl.NumberFormat('es-MX', { style: 'currency', currency: window.benivoxMoneda || 'MXN' }).format(valor);
        const grupos = (n, dec, miles, decimal) => {
          const partes = n.toFixed(dec).split('.');
          partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
          return partes.length > 1 ? partes[0] + decimal + partes[1] : partes[0];
        };
        return formato.replace(/\{\{\s*(\w+)\s*\}\}/, (m, clave) => {
          if (clave === 'amount_no_decimals') return grupos(Math.round(valor), 0, ',', '.');
          if (clave === 'amount_with_comma_separator') return grupos(valor, 2, '.', ',');
          if (clave === 'amount_no_decimals_with_comma_separator') return grupos(Math.round(valor), 0, '.', ',');
          return grupos(valor, 2, ',', '.');
        });
      },
      variantId(sectionId) {
        const input = (sectionId && document.querySelector(`#product-form-${sectionId} input[name="id"]`)) || document.querySelector('form[id^="product-form-"]:not([id*="installment"]) input[name="id"]');
        return input && input.value ? Number(input.value) : null;
      },
      track(evento, variantId, quantity, priceCents, activo) {
        if (!activo) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: evento, variant_id: variantId, quantity, value: (Number(priceCents || 0) * quantity) / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || window.benivoxMoneda });
      },
      async addToCart(variantId, quantity, source) {
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!cart) {
          const r = await fetch(routes.cart_add_url, { ...fetchConfig('javascript'), body: JSON.stringify({ items: [{ id: variantId, quantity }] }) });
          const s = await r.json();
          if (!s.status) window.location.href = routes.cart_url;
          return s;
        }
        const body = { items: [{ id: variantId, quantity }], sections: cart.getSectionsToRender().map((s) => s.id), sections_url: window.location.pathname };
        const response = await fetch(routes.cart_add_url, { ...fetchConfig('javascript'), body: JSON.stringify(body) });
        const state = await response.json();
        if (state.status) {
          publish(PUB_SUB_EVENTS.cartError, { source, productVariantId: variantId, errors: state.errors || state.description, message: state.message });
          return state;
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source, productVariantId: variantId, cartData: state });
        cart.renderContents(state);
        cart.classList.remove('is-empty');
        cart.querySelector('.drawer__inner')?.classList.remove('is-empty');
        return state;
      },
    };
  }

  if (window.benivoxCtas) return;
  window.benivoxCtas = true;
  const B = window.benivox;

  const pack = (precio) => {
    const s = document.querySelector('benivox-packs .benivox-pack__input:checked');
    if (!s) return { u: 1, total: precio };
    const u = Number(s.dataset.unidades) || 1;
    const d = Number(s.dataset.descuento) || 0;
    return { u, total: Math.floor((precio * u * (100 - d)) / 100) };
  };

  const refrescar = () => {
    document.querySelectorAll('[data-benivox-cta]').forEach((b) => {
      const precio = Number(b.dataset.precio);
      const { u, total } = b.dataset.cantidad === 'pack' ? pack(precio) : { u: 1, total: precio };
      b.dataset.unidades = u;
      b.dataset.total = total;
      const disponible = b.dataset.disponible === 'true';
      if (b.getAttribute('aria-busy') !== 'true') b.disabled = !disponible;
      const t = b.querySelector('[data-benivox-cta-texto]');
      if (t && b.dataset.texto) t.textContent = disponible ? b.dataset.texto.replace('[[precio]]', B.money(total)) : b.dataset.textoAgotado || '';
    });
  };

  const aplicarVariante = (v) => {
    if (!v) {
      document.querySelectorAll('[data-benivox-cta]').forEach((b) => { b.dataset.disponible = 'false'; });
      refrescar();
      return;
    }
    document.querySelectorAll('[data-benivox-cta]').forEach((b) => {
      b.dataset.precio = v.price;
      b.dataset.variante = v.id;
      b.dataset.disponible = String(v.available);
    });
    document.querySelectorAll('[data-benivox-precio-vivo]').forEach((el) => { el.textContent = B.money(v.price); });
    const hay = v.compare_at_price && v.compare_at_price > v.price;
    document.querySelectorAll('[data-benivox-tachado-vivo]').forEach((el) => {
      el.hidden = !hay;
      if (hay) el.textContent = B.money(v.compare_at_price);
    });
    document.querySelectorAll('[data-benivox-ahorro-vivo]').forEach((el) => {
      el.hidden = !hay;
      if (!hay) return;
      const diff = v.compare_at_price - v.price;
      const valor = el.dataset.formato === 'importe' ? B.money(diff) : Math.floor((diff * 100) / v.compare_at_price) + '%';
      el.textContent = (el.dataset.texto || '[[valor]]').replace('[[valor]]', valor);
    });
    if (v.featured_image && v.featured_image.src) {
      document.querySelectorAll('[data-benivox-foto-vivo]').forEach((img) => {
        const src = v.featured_image.src;
        img.src = src + (src.includes('?') ? '&' : '?') + 'width=' + (img.dataset.ancho || 200);
        img.removeAttribute('srcset');
      });
    }
    refrescar();
  };

  const comprar = async (b) => {
    const accion = b.dataset.accion;
    const u = Number(b.dataset.unidades) || 1;
    const variantId = B.variantId('') || Number(b.dataset.variante);
    const error = b.closest('[data-benivox-cta-caja]')?.querySelector('[data-benivox-cta-error]');
    const tracking = b.dataset.tracking === 'true';
    if (error) error.textContent = '';
    if (accion === 'url' && b.dataset.url) {
      window.location.href = b.dataset.url;
      return;
    }
    if (accion === 'formulario' || !variantId) {
      const destino = document.querySelector('benivox-packs') || document.querySelector('form[id^="product-form-"]:not([id*="installment"])');
      if (destino) destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else if (b.dataset.url) window.location.href = b.dataset.url;
      return;
    }
    if (accion === 'checkout') {
      B.track('benivox_initiate_checkout', variantId, u, b.dataset.precio, tracking);
      window.location.href = `${routes.cart_url}/${variantId}:${u}`;
      return;
    }
    b.setAttribute('aria-busy', 'true');
    b.disabled = true;
    try {
      const state = await B.addToCart(variantId, u, 'benivox-cta');
      if (state && state.status) {
        if (error) error.textContent = state.description || state.message || b.dataset.textoError || '';
      } else {
        B.track('benivox_add_to_cart', variantId, u, b.dataset.precio, tracking);
      }
    } catch (e) {
      if (error) error.textContent = b.dataset.textoError || '';
    } finally {
      b.removeAttribute('aria-busy');
      refrescar();
    }
  };

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-benivox-cta]');
    if (!b || b.disabled || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    comprar(b);
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches && e.target.matches('.benivox-pack__input')) refrescar();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => aplicarVariante(data && data.variant));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refrescar, { once: true });
  else refrescar();
  document.addEventListener('shopify:section:load', refrescar);
})();

// El header BENIVOX no tiene #cart-icon-bubble de Dawn: sin este filtro, cambiar la cantidad en el carrito muestra un error falso.
['cart-drawer-items', 'cart-items'].forEach((tag) => {
  customElements.whenDefined(tag).then(() => {
    const proto = customElements.get(tag).prototype;
    if (Object.prototype.hasOwnProperty.call(proto, 'benivoxFiltrado')) return;
    const original = proto.getSectionsToRender;
    proto.getSectionsToRender = function () {
      return original.call(this).filter((s) => document.getElementById(s.id));
    };
    proto.benivoxFiltrado = true;
  });
});
